import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-department-config',
  standalone: false,
  templateUrl: './global-department-config.component.html',
  styleUrls: ['./global-department-config.component.scss']
})
export class GlobalDepartmentConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit(): void {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-department',
        approxamateRowCount: 1000,
        anyParams: true,
      },
      colConfig: [
        { field: 'departmentId', header: 'Department ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true },
        { field: 'departmentName', header: 'Department Name', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add Global Department'
      },
      isConfigurable: true,
      canEdit: false
    };
  }

}
